module.exports = __webpack_public_path__ + "img/tk1.0fe69055.jpeg";